import classNames from "classnames"
import scrollIntoView from "scroll-into-view-if-needed"

export function getInputStyle(showError: boolean) {
    return classNames("contact-request-popup__input transition-ease", {
        "contact-request-popup__input-error": showError,
    })
}

export function scrollIntoViewWithOptions(element: Element) {
    scrollIntoView(element, {
        scrollMode: "if-needed",
        block: "nearest",
        inline: "nearest",
    })
}
